<template>
    <dx-load-indicator id="large-indicator" :height="60" :width="60" />
</template>
<script>
export default {
    name: 'dx-loader',
};
</script>
<script setup>
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
</script>
